<script>
import { mapActions } from 'vuex';
import axios from 'axios';
import RbxConfirmDialog from '@/shared/reybex/RbxConfirmDialog';
import mainViewTabMixin from '../../mixins/mainViewTab';
import snackbarMixin from '../../mixins/snackbar';
import QuestionList from './components/QuestionList';

export default {
  name: 'QuestionaryDetails',
  components: {
    QuestionList,
    RbxConfirmDialog,
  },
  mixins: [mainViewTabMixin, snackbarMixin],
  data() {
    return {
      query: {},
      params: {},
      questionary: {},
      isLoading: false,
      isSaving: false,
      hasError: false,
      activeTab: 0,
      isDownloading: false,
      categoryName: '',
    };
  },
  created() {
    const { query, params } = this.urlParser('/questionary/:id?', this.path);
    this.params = query;
    if (params && params.id) {
      this.params.id = params.id;
    }

    // TODO: Refactor. One call of urlParser must be used.
    if (!this.params.id) {
      const { _query, _params } = this.urlParser('/questionary/:id?:categoryId?', this.path);
      if (_query && _params.id) {
        this.params.id = _params.id;
      }
    }
    this.fetchData();
  },
  methods: {
    ...mapActions('questionaryDetails', ['fetchQuestionary', 'saveQuestionary']),
    ...mapActions('questionaryList', ['downloadReport']),
    fetchData() {
      this.isLoading = true;
      this.hasError = false;

      return this.fetchQuestionary(this.params)
        .then(({ data }) => {
          this.questionary = data;
          this.categoryName = data.category.name;
          this.updateTabTitle({
            path: this.path,
            title: this.questionary.id ? this.questionary.name : 'Neuer Fragenkatalog',
          });
        })
        .catch((x) => {
          console.log('ERROR', x);
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    save() {
      if (!this.questionary.name) {
        this.showErrorMessage('Bitte tragen Sie eine Bezeichnung für den Fragenkatalog ein.');
      } else {
        this.isSaving = true;
        axios.post('/questionary', this.questionary)
          .then((response) => {
            this.showSuccessMessage('Der Fragenkatalog wurde gespeichert.');
            this.questionary = response.data;
          })
          .catch(() => {
            this.showErrorMessage('Der Speichervorgang ist fehlgeschlagen.');
          })
          .finally(() => {
            this.isSaving = false;
          });
      }
    },
  },
};
</script>

<template>
  <div>
    <v-progress-linear v-if="isLoading" :indeterminate="true"/>

    <span
      v-else-if="hasError"
      class="js-error ma-3"
    >Beim Laden des Fragenkatalogs ist ein technischer Fehler aufgetreten.
    </span>

    <v-form v-else>
      <v-container fluid grid-list-lg pt-2 pa-0>

        <v-toolbar dark dense height="40" color="blue-grey lighten-2">
          <v-tooltip bottom>
            <v-btn @click="save" :loading="isSaving" icon slot="activator">
              <v-icon>save</v-icon>
            </v-btn>
            <span>Speichern</span>
          </v-tooltip>

        </v-toolbar>

        <v-layout row wrap>
          <v-flex xs6 md3 py-0>
            <v-text-field
              v-model="categoryName"
              label="Kategorie"
              height="22"
              class="caption"
              :disabled="true"
            />
          </v-flex>

          <v-flex xs6 md3 py-0>
            <v-text-field
              v-model="questionary.name"
              label="Bezeichnung"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex xs6 md12 py-0>
            <question-list :questions="questionary.questions" />
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>
